import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import { WithClassName } from '@types';

export type ColorFilter = 'b&w' | 'color';

interface FilterProps {
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
  title: string;
}

const Filter = ({
  children,
  className,
  isOpen,
  onClose,
  onOpen,
  title,
}: FilterProps & WithClassName & PropsWithChildren) => {
  const toggle = () => (isOpen ? onClose() : onOpen());

  return (
    <div
      className={classNames(
        'flex items-center justify-center tablet:justify-end h-5 tablet:h-8 text-sm transition-all',
        className,
      )}
    >
      <span
        className="italic cursor-pointer text-nowrap transition-colors hover:text-accent"
        onClick={toggle}
      >
        {isOpen ? '-' : '+'} {title}
      </span>
      <div
        className={classNames(
          'flex items-center gap-2 transition-all overflow-hidden',
          isOpen
            ? 'max-w-[200px] ml-4 opacity-100'
            : 'max-w-0 ml-0 opacity-0 pointer-events-none',
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default Filter;
